import React from "react";
import mariaAvatar from "../../../assets/maria-m-avatar.jpeg";

export default function HomeHeaderBanner({
  userName = "Viviane Garcia",
  pressure = "120/80",
  dosesDone = 3,
  dosesTotal = 4,
  percent = 75,
  onOpenMariaChat,
  onOpenNotifications,
  onOpenSummary,
  onNavigateRoutine,
  onNavigateEvolution,
  hasUnreadNotifications = false,
}) {
  return (
    <div className="space-y-3">
      {/* 1. TOP BAR DO APP */}
      <div className="flex items-center justify-between flex-shrink-0 pt-1 px-1">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-2xl bg-gradient-to-tr from-[#502CB8] to-[#7B53E3] flex items-center justify-center text-white font-black text-base shadow-sm">
            M
          </div>
          <div>
            <span className="font-black text-[#1E192B] text-lg tracking-tight leading-none block">
              Maria <span className="text-[#643AD9]">M</span>
            </span>
            <span className="text-[10px] font-bold tracking-wider text-purple-900/60 uppercase block mt-0.5">
              Saúde em Dia
            </span>
          </div>
        </div>

        <button
          type="button"
          onClick={onOpenNotifications}
          className="w-9 h-9 rounded-2xl bg-white border border-purple-100 flex items-center justify-center text-[#4A2E99] shadow-xs hover:bg-purple-50 transition relative active:scale-95 cursor-pointer"
          title="Notificações e Lembretes"
        >
          <svg
            className="w-5 h-5 text-[#5A38C2]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            />
          </svg>
          {hasUnreadNotifications && (
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-[#E63946] border-2 border-white rounded-full"></span>
          )}
        </button>
      </div>

      {/* 2. BANNER EM 4 PARTES: FOTO | NOME COMPLETO | PÍLULAS COMPACTAS [120/80] & [3/4 ok] | 75% HOJE */}
      <div className="rounded-3xl p-3.5 text-white shadow-xl shadow-purple-950/20 relative overflow-hidden bg-gradient-to-br from-[#421F97] via-[#2E146E] to-[#1D0A4C]">
        {/* Glow decorativo de fundo */}
        <div className="absolute -right-8 -bottom-8 h-32 w-32 rounded-full bg-purple-400/20 blur-2xl pointer-events-none" />
        <div className="absolute right-20 top-0 h-20 w-20 rounded-full bg-emerald-400/10 blur-xl pointer-events-none" />

        <div className="relative z-10 flex items-center justify-between gap-2.5">
          {/* PARTE 1: FOTO DA MARIA M (56px) */}
          <button
            type="button"
            onClick={onOpenMariaChat}
            title="Tocar para conversar com a MarIA"
            className="relative group flex-shrink-0 cursor-pointer active:scale-95 transition-transform"
          >
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-tr from-purple-300 via-pink-300 to-indigo-200 p-0.5 shadow-md group-hover:scale-105 transition overflow-hidden flex items-center justify-center">
              <img
                src={mariaAvatar}
                alt="Avatar Oficial Maria M"
                className="w-full h-full object-cover object-top rounded-[14px]"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=160&auto=format&fit=crop&q=80";
                }}
              />
            </div>
            <span className="absolute -bottom-1 -right-1 w-4.5 h-4.5 bg-emerald-500 rounded-full flex items-center justify-center text-white text-[9px] font-bold border-2 border-[#2E146E] shadow-sm">
              💬
            </span>
          </button>

          {/* PARTE 2: SAUDAÇÃO & NOME COMPLETO COM ESPAÇO LIVRE */}
          <div className="flex-1 min-w-0 pr-1">
            <span className="text-[10px] font-extrabold text-purple-200 uppercase tracking-wider block leading-none">
              Olá,
            </span>
            <h2 className="text-base font-black text-white leading-tight mt-0.5 truncate">
              {userName} 👋
            </h2>
          </div>

          {/* PARTE 3: PRESSÃO E REMÉDIOS COMPACTOS */}
          <div className="flex flex-col gap-1.5 flex-shrink-0">
            {/* Linha 1: 🩺 120/80 */}
            <button
              type="button"
              onClick={onNavigateEvolution}
              className="rounded-full px-3 py-1 flex items-center justify-center gap-2 cursor-pointer hover:bg-white/20 transition bg-white/15 backdrop-blur-md border border-white/20 shadow-2xs text-left"
              title="Ver registros de pressão"
            >
              <span className="text-xs leading-none">🩺</span>
              <span className="text-xs font-black text-white tracking-tight leading-none">
                {pressure}
              </span>
            </button>

            {/* Linha 2: 💊 3/4 ok */}
            <button
              type="button"
              onClick={onNavigateRoutine}
              className="rounded-full px-3 py-1 flex items-center justify-center gap-2 cursor-pointer hover:bg-white/20 transition bg-white/15 backdrop-blur-md border border-white/20 shadow-2xs text-left"
              title="Ver rotina de doses"
            >
              <span className="text-xs leading-none">💊</span>
              <span className="text-xs font-black text-emerald-300 tracking-tight leading-none">
                {dosesDone}/{dosesTotal} ok
              </span>
            </button>
          </div>

          {/* PARTE 4: 75% HOJE */}
          <button
            type="button"
            onClick={onOpenSummary}
            className="rounded-2xl px-2 py-1.5 flex flex-col items-center justify-center text-center flex-shrink-0 border border-emerald-400/30 bg-emerald-500/15 shadow-xs cursor-pointer hover:bg-emerald-500/25 transition active:scale-95"
            title="Ver resumo do dia"
          >
            <span className="text-xs font-black text-emerald-300 tracking-tight leading-none">
              {percent}%
            </span>
            <span className="text-[8px] font-black uppercase text-purple-200 tracking-wider mt-0.5">
              HOJE
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
